import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Flags from '../flags'

import Byzans from './byzans'
import Download from './download'
import Follow from './follow'

type FooterProps = {
    bg?: string
}

const Footer: React.FunctionComponent<FooterProps> = ({ bg }) => (
    <Container bg={bg}>
        <Wrapper>
            <Byzans />
            <Download />
            <Follow />
        </Wrapper>
        <Flags />
    </Container>
)

const Container = styled.div<{ bg?: string }>`
    display: grid;
    justify-items: flex-start;
    
    grid-gap: 20px;

    width: 100%;
    padding: 40px 20px;

    background: ${p => p.bg ? p.bg : '#21212F'};

    ${up('tablet')} {
        justify-items: center;
        padding: 60px 32px;
    }

    ${up('desktop')} {
        padding: 60px 80px;
    }
`

const Wrapper = styled.div`
    display: grid;
    width: 100%;

    ${up('tablet')} {
        grid-template-columns: 1fr 1fr;
    }

    ${up('desktop')} {
        grid-template-columns: 1fr 1fr 1fr;

        max-width: 1440px;
    }
`

export default Footer